export function numericSort(a: number, b: number) {
  return a - b;
}
